import dayjs from 'dayjs';
import { getFormattedToMonthDateWithDayOfWeek } from '../util';
export class Mission {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isAchieved", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isNew", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "kind", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "achievedAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "completeImageSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "incompleteImageSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.code = data.code;
        this.name = data.name;
        this.isAchieved = data.isAchieved;
        this.isNew = data.isNew;
        this.kind = data.kind;
        this.achievedAt = data.achievedAt;
        this.completeImageSrc = data.completeImageSrc;
        this.incompleteImageSrc = data.incompleteImageSrc;
        this.config = config;
    }
    get completeImageURL() {
        return new URL(this.completeImageSrc, `${this.config.cdnBaseURL.replace(/\/$/, '')}/`).toString();
    }
    get incompleteImageURL() {
        return new URL(this.incompleteImageSrc, `${this.config.cdnBaseURL.replace(/\/$/, '')}/`).toString();
    }
}
export class BeginnerMission {
    constructor(data, config) {
        Object.defineProperty(this, "homeDisplayStartDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "homeDisplayEndDate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shouldShowOnLogin", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "items", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.homeDisplayStartDate = data.homeDisplayStartDate;
        this.homeDisplayEndDate = data.homeDisplayEndDate;
        this.shouldShowOnLogin = data.shouldShowOnLogin;
        this.items = data.items.map((item) => new Mission(item, config));
    }
    get periodLabel() {
        return `${getFormattedToMonthDateWithDayOfWeek(dayjs(this.homeDisplayStartDate).toDate())}〜${getFormattedToMonthDateWithDayOfWeek(dayjs(this.homeDisplayEndDate).toDate())}`;
    }
    get achievedCount() {
        return this.items.filter((item) => item.isAchieved).length;
    }
    get isCompleted() {
        return this.items.length > 0 && this.achievedCount === this.items.length;
    }
    hasJustCompleted(previousAchievedCount) {
        return previousAchievedCount !== null && previousAchievedCount < this.items.length && this.isCompleted;
    }
    get isWithinHomeDisplayPeriod() {
        if (!this.homeDisplayStartDate || !this.homeDisplayEndDate)
            return false;
        const now = dayjs();
        const startsAt = dayjs(`${this.homeDisplayStartDate}T00:00:00+09:00`);
        const endsAt = dayjs(`${this.homeDisplayEndDate}T23:59:59.999+09:00`);
        return !now.isBefore(startsAt) && !now.isAfter(endsAt);
    }
}
export class MissionSummary {
    constructor(data, config) {
        Object.defineProperty(this, "missions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasUnviewedMissions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.missions = data.missions.map((mission) => new Mission(mission, config));
        this.hasUnviewedMissions = data.hasUnviewedMissions;
    }
}
export class MissionGroup {
    constructor(data, config) {
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "missions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.code = data.code;
        this.name = data.name;
        this.missions = data.missions.map((mission) => new Mission(mission, config));
    }
}
export class MissionList {
    constructor(data, config) {
        Object.defineProperty(this, "missionGroups", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "hasUnviewedMissions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.missionGroups = data.missionGroups.map((group) => new MissionGroup(group, config));
        this.hasUnviewedMissions = data.hasUnviewedMissions;
    }
}
